import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HumanizeDuration, HumanizeDurationLanguage } from 'humanize-duration-ts';

@Pipe({ name: 'humanizedDate' })
export class HumanizedDatePipe implements PipeTransform {
  private translate = inject(TranslateService);

  private langService: HumanizeDurationLanguage;
  private humanizer: HumanizeDuration;

  constructor() {
    this.langService = new HumanizeDurationLanguage();
    this.humanizer = new HumanizeDuration(this.langService);

    this.humanizer.setOptions({
      language: this.getLocale(),
      delimiter: ' ',
      units: ['h', 'm'],
      round: true,
    });
  }

  public getLocale(): string {
    switch (this.translate.currentLang()) {
      case 'de-DE': {
        return 'de';
      }

      case 'en-US': {
        return 'en';
      }

      default: {
        return 'de';
      }
    }
  }

  getText(date: Date): string {
    const now = new Date();
    const duration = Math.abs(now.getTime() - date.getTime());
    return this.humanizer.humanize(duration);
  }

  transform(value: string | Date): string {
    if(value === null) return null;
    let date = new Date();
    if(typeof(value) === 'string') {
      date = new Date(value)
    }
    return this.getText(date);
  }

}
